import { createContext, useState, useContext } from "react";

const rawTranslations = {
  pt: {
    language: "pt",
    aboutTitle: "Sobre mim",
    aboutDescription: `Oii Jóia ✨ Que bom te ter aqui!
    *Me chamo Glória (oficialmente Lívia) Tenho 23 anos e sou uma mineira apaixonada por tecnologia, animes, livros e gatinhos 🥰
    *Sou formada em ADS e curso Engenharia de Software. Atuo como Estagiária de Desenv. de Sistemas Java no Banco BV.
    *Estou sempre em busca de aprendizado, novas experiências e boas trocas! Se quiser bater um papo, é só clicar lá em cima e me chamar nas redes 💌 
    *Tô sempre por aqui ❤`,
    downloadCV: "Baixar CV",
    projects: "Projetos completos",
    cups: "Copos de coca-cola",
    experiences: "Experiência na área",
    certificates: "Certificados",
    blogTitle: "Posts recentes",
    contactTitle: "Entre em contato 🌹",
    contactMessage: "Se tiver alguma pergunta ou apenas quiser bater um papo sobre meus projetos, me manda uma mensagem!",
    sendMessage: "Enviar mensagem",
    blogCategory1: "Experiências",
    blogCategory2: "Dicas Profissionais",
    blogCategory3: "Dicas Profissionais",
    blogTheme1: "Finalmente aconteceu!",
    blogTheme2: "Vencendo a Gupy!",
    blogTheme3: "Dicas de processos seletivos",
    blogDate1: "28 Março, 2025",
    blogDate2: "06 Novembro, 2024",
    blogDate3: "26 Maio, 2025",
    writeMessage: "Escreva sua mensagem",
    subjectMessage: "Digite o assunto",
    emailContact: "Informe seu email",
    nameContact: "Informe seu nome",
    careerTitle: "Engenheira de Software",
    quoteMessage: "“Não aceito mais as coisas que não posso mudar, estou mudando as coisas que não posso aceitar”",
    contactMe: "Fala comigo :]",
    projectsTitle: "Principais projetos",
    projectsAll: "Tudo",
    projectTop1Title: "Organização de Eventos",
    projectTop2Title: "Gerenciamento Biblioteca",
    projectTop3Title: "API Agência de Viagens",
    projectTop4Title: "Gerenciamento de Estoque",
    projectTop5Title: "Gerenciamento de Petshop",
    projectTop6Title: "Jogo de Xadrez",
    projectTop7Title: "Produtividade e gestão pessoal - Time Wise",
    projectTop8Title: "Gerenciamento de Funcionários",
    projectTop9Title: "Plataforma para Clínicas Médicas",
    projectTop10Title: "Portfólio Simples",
    experienceTitle: "Formações e Experiências",
    education1Date: "julho 2024 - em andamento",
    education1Title: "Bacharelado em Engenharia de Software",
    education1Desc: "Descomplica     *Formação prevista: junho 2028",
    education2Date: "janeiro 2022 - junho 2024",
    education2Title: "Tecnólogo em Análise e Desenvolvimento de Sistemas",
    education2Desc: "Estácio *Formação em linguagens de programação, banco de dados, desenvolvimento web, redes e segurança da informação. Habilidades para atuar como desenvolvedor e analista de sistemas.",
    career1Date: "março 2025 - atualmente",
    career1Title: "Estagiária Desenv. de Sistemas Java @Banco BV",
    career1Desc:"*Microsserviços, Java (11), GCP, Kibana, MySQL, Spring, Kafka",
    career2Date: "agosto 2025 - outubro 2025",
    career2Title: "Desenvolvedora Backend @Ujamaatech",
    career2Desc: "*Next.Js, Botpress, Wix, Inteligência Artificial, Desenvolvimento de Chatbots",
    career3Date: "julho 2022 - janeiro 2024",
    career3Title: "Estagiária de Dados @Bemobi",
    career3Desc: "*SQL, Bitbucket, JIRA, Confluence, Airflow, Tableau, Looker, Metodologias Ágeis (SCRUM e Kanban)",
    project23Date: "dezembro de 2024",
    project23Title: "23. Sistema de Anotações",
    project23Desc: "• Projetinho simples feito durante a ultima aula de JS do semestre :]",
    project22Date: "julho de 2024",
    project22Title: "22. Portfólio Simples",
    project22Desc: "• Projeto feito como avaliação final da disciplina Prog. Web",
    project21Date: "julho de 2024",
    project21Title: "21. Eclipse Hotel",
    project21Desc: "• Sistema de gestão de hotel, desenvolvido para um teste técnico.",
    project20Date: "julho de 2024",
    project20Desc: "• O projeto tem como objetivo ajudar o usuário a organizar viagens, programar atividades, convidar pessoas.",
    project19Date: "julho de 2024",
    project19Desc: "• Este aqui que você está vendo :]",
    project18Date: "junho de 2024",
    project18Title: "18. Agência de Viagens",
    project18Desc: "• API RESTful para uma agência de viagens.",
    project17Date: "abril de 2024",
    project17Desc: "• Sistema para médicos e pacientes com funcionalidades de agendamento e gestão de consultas.",
    project16Date: "abril de 2024",
    project16Desc: "• Plataforma para gerenciamento de eventos presenciais, permitindo criação e check-in de eventos.",
    project15Date: "janeiro de 2024",
    project15Desc: "• Sistema full stack para gerenciamento de tarefas e controle de gastos.",
    project14Date: "novembro de 2023",
    project14Title: "14. Banco de Talentos",
    project14Desc: "• CRUD simples de um sistema de armazenamento de dados.",
    project13Date: "novembro de 2023",
    project13Title: "13. Gerenciamento de Estoque",
    project13Desc: "• Sistema para gerenciamento de estoque de lojas, com interface gráfica.",
    project12Date: "novembro de 2023",
    project12Title: "12. Homepage",
    project12Desc: "• Página inicial de um site com tema One Piece.",
    project11Date: "novembro de 2023",
    project11Title: "11. Jogo da Velha",
    project11Desc: "• O joguinho que todos conhecemos bem...",
    project10Date: "outubro de 2023",
    project10Title: "10. Gerenciamento de Biblioteca",
    project10Desc: "• Sistema de gerenciamento com biblioteca para interface gráfica.",
    project9Date: "outubro de 2023",
    project9Title: "9. Gerenciamento de PetShop",
    project9Desc: "• Sistema de gerenciamento com biblioteca para interface gráfica.",
    project8Date: "janeiro de 2023",
    project8Title: "8. Jogo de Xadrez",
    project8Desc: "• Jogo de xadrez desenvolvido para melhorar os conceitos de programação orientada a objetos.",
    project7Date: "março de 2022",
    project7Title: "7. Página Portfolio",
    project7Desc: "• Página de portfólio criada durante a Imersão DEV.",
    project6Date: "março de 2022",
    project6Title: "6. Super Trunfo (Genshin Impact)",
    project6Desc: "• Jogo de Super Trunfo usando personagens de Genshin Impact, dessa vez com mais funcionalidades e estilização",
    project5Date: "março de 2022",
    project5Title: "5. Super Trunfo (Hololive EN)",
    project5Desc: "• Jogo de Super Trunfo simples, usando personagens do grupo Hololive EN",
    project4Date: "março de 2022",
    project4Title: "4. Tabela de Classificação",
    project4Desc: "• Página simples para exibir e gerenciar tabelas de classificação",
    project3Date: "março de 2022",
    project3Title: "3. O Mentalista",
    project3Desc: "• Aplicação de adivinhação de números.",
    project2Date: "março de 2022",
    project2Desc: "• Projeto feito na Imersão DEV, onde criamos uma aplicação para listar filmes ou séries.",
    project1Date: "março de 2022",
    project1Title: "1. Conversor de Moedas",
    project1Desc: "• Um conversor de moedas simples.",
    testimonialsTitle: "Recomendações",
    testimonialsSubtitle: "Líder Técnico em Analytics Engineering na Bemobi",
    testimonialsComment: "Foi uma estagiária valiosa no time de Analytics Engineering, responsável pela construção e manutenção de pipelines de dados. Demonstrou sólido conhecimento em SQL e um forte interesse por programação e automação de processos. Se destacou contribuindo para entregas de qualidade e dentro dos prazos além de foco no planejamento e desenvolvimento de carreira. Recomendo Lívia como uma profissional com boa aptidão técnica, com potencial para agregar valor a qualquer equipe.",
    servicesTitle: "Tecnologias",
    toolsTitle: "Outras ferramentas",
  },
  en: {
    language: "en",
    aboutTitle: "About me",
    aboutDescription: `Hey there! ✨ So glad to have you here!
    *I'm Glória (officially Lívia)  I'm a Brazilian girl from Minas Gerais who’s passionate about technology, anime, books and cats 🥰
    *I hold a degree in IT and I'm currently studying Software Engineering. I work as a Java Backend Development Intern at Banco BV.
    *Always looking to learn, grow, and connect! Wanna chat? Just click up there and hit me up on my socials 💌
    *I'm always around ❤`,
    downloadCV: "Download CV",
    projects: "Completed projects",
    cups: "Coca-Cola drinks",
    experiences: "Experience in the field",
    certificates: "Certificates",
    blogTitle: "Recent posts",
    contactTitle: "Get in touch 🌹",
    contactMessage: "If you have any questions or just want to chat about my projects, feel free to send me a message!",
    sendMessage: "Send message",
    blogCategory1: "Experiences",
    blogCategory2: "Professional Tips",
    blogCategory3: "Professional Tips",
    blogTheme1: "It finally happened!",
    blogTheme2: "Beating Gupy!",
    blogTheme3: "Tips for job interviews",
    blogDate1: "March 28, 2025",
    blogDate2: "November 06, 2024",
    blogDate3: "May 26, 2025",
    writeMessage: "Write your message",
    subjectMessage: "Insert the subject",
    emailContact: "Write your email",
    nameContact: "Insert your name",
    careerTitle: "Software Engineer",
    quoteMessage: "“I am no logger accepting the things I cannot change. I am changing the things I cannot accept.”",
    contactMe: "Talk to me :]",
    projectsTitle: "Mainly Projects",
    projectsAll: "All",
    projectTop1Title: "Event Organization",
    projectTop2Title: "Library Management",
    projectTop3Title: "Travel Agency API",
    projectTop4Title: "Inventory Management",
    projectTop5Title: "Pet Shop Management",
    projectTop6Title: "Chess Game",
    projectTop7Title: "Productivity and Personal Management - Time Wise",
    projectTop8Title: "Employee Management",
    projectTop9Title: "Medical Clinics Platform",
    projectTop10Title: "Simple Portfolio",
    experienceTitle: "Graduations & Experiences",
    education1Date: "july 2024 - ongoing",
    education1Title: "Bachelor's in Software Engineering",
    education1Desc: "Faculdade Descomplica *Expected graduation: june 2028",
    education2Date: "january 2022 - june 2024",
    education2Title: "Associate Degree in Systems Analysis and Development",
    education2Desc: "Estácio *Training in programming languages, databases, web development, networking, and information security. Gained skills to work as a developer and systems analyst.",
    career1Date: "march 2025 - present",
    career1Title: "Java Systems Development Intern @Banco BV",
    career1Desc:"*Microservices, Java (11), GCP, Kibana, MySQL, Spring, Kafka",
    career2Date: "august 2025 - october 2025",
    career2Title: "Backend Developer @Ujamaatech",
    career2Desc: "Next.Js, Botpress, Wix, Artificial Intelligence, Chatbots Development",
    career3Date: "july 2022 - january 2024",
    career3Title: "Data Intern @Bemobi",
    career3Desc: "*SQL, Bitbucket, JIRA, Confluence, Airflow, Tableau, Looker, Agile methodologies (SCRUM and Kanban)",
    project23Date: "december 2024",
    project23Title: "23. Note System",
    project23Desc: "• Simple project made during the last JS class of the semester :]",
    project22Date: "july 2024",
    project22Title: "22. Simple Portfolio",
    project22Desc: "• Project made as final evaluation for the Web Programming course.",
    project21Date: "july 2024",
    project21Title: "21. Eclipse Hotel",
    project21Desc: "• Hotel management system developed for a technical assessment.",
    project20Date: "july 2024",
    project20Desc: "• The project helps users organize trips, schedule activities, and invite others.",
    project19Date: "july 2024",
    project19Desc: "• This one you're looking at :]",
    project18Date: "june 2024",
    project18Title: "18. Travel Agency",
    project18Desc: "• RESTful API for a travel agency.",
    project17Date: "april 2024",
    project17Desc: "• System for doctors and patients with scheduling and appointment management features.",
    project16Date: "april 2024",
    project16Desc: "• Platform for managing in-person events, allowing creation and check-in.",
    project15Date: "january 2024",
    project15Desc: "• Full stack system for task management and expense control.",
    project14Date: "november 2023",
    project14Title: "14. Talent Bank",
    project14Desc: "• Simple CRUD for a data storage system.",
    project13Date: "november 2023",
    project13Title: "13. Stock Management",
    project13Desc: "• Inventory management system for stores, with graphical interface.",
    project12Date: "november 2023",
    project12Title: "12. Homepage",
    project12Desc: "• Homepage of a website with One Piece theme.",
    project11Date: "november 2023",
    project11Title: "11. Tic-Tac-Toe",
    project11Desc: "• The classic game we all know and love...",
    project10Date: "october 2023",
    project10Title: "10. Library Management",
    project10Desc: "• Management system with graphical interface library.",
    project9Date: "october 2023",
    project9Title: "9. PetShop Management",
    project9Desc: "• Management system with graphical interface library.",
    project8Date: "january 2023",
    project8Title: "8. Chess Game",
    project8Desc: "• Chess game developed to improve OOP concepts.",
    project7Date: "march 2022",
    project7Title: "7. Portfolio Page",
    project7Desc: "• Portfolio page created during the DEV Immersion.",
    project6Date: "march 2022",
    project6Title: "6. Super Trunfo (Genshin Impact)",
    project6Desc: "• Super Trunfo game using Genshin Impact characters, with extra features and style.",
    project5Date: "march 2022",
    project5Title: "5. Super Trunfo (Hololive EN)",
    project5Desc: "• Simple Super Trunfo game using Hololive EN characters.",
    project4Date: "march 2022",
    project4Title: "4. Ranking Table",
    project4Desc: "• Simple page to display and manage ranking tables.",
    project3Date: "march 2022",
    project3Title: "3. The Mentalist",
    project3Desc: "• Number guessing game.",
    project2Date: "march 2022",
    project2Desc: "• Project from the DEV Immersion, creating a movie/series listing app.",
    project1Date: "march 2022",
    project1Title: "1. Currency Converter",
    project1Desc: "• A simple currency converter.",
    testimonialsTitle: "Recommendations",
    testimonialsSubtitle: "Technical Leader in Analytics Engineering at Bemobi",
    testimonialsComment: "She was a valuable intern in the Analytics Engineering team, responsible for building and maintaining data pipelines. She demonstrated solid knowledge in SQL and a strong interest in programming and process automation. She stood out by contributing to quality deliveries within deadlines, with a focus on planning and career development. I recommend Lívia as a professional with good technical aptitude, with potential to add value to any team.",
    servicesTitle: "Technologies",
    toolsTitle: "Other tools",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("pt"); 

  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === "pt" ? "en" : "pt"));
  };

  const translations = rawTranslations[language];

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
